var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 1.66699H5.0026C4.56058 1.66699 4.13665 1.84259 3.82409 2.15515C3.51153 2.46771 3.33594 2.89163 3.33594 3.33366V16.667C3.33594 17.109 3.51153 17.5329 3.82409 17.8455C4.13665 18.1581 4.56058 18.3337 5.0026 18.3337H15.0026C15.4446 18.3337 15.8686 18.1581 16.1811 17.8455C16.4937 17.5329 16.6693 17.109 16.6693 16.667V7.50033L10.8359 1.66699Z",
    fill: "#CECECE",
    stroke: "#CECECE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 1.66699V5.50032C10.8359 6.60489 11.7314 7.50033 12.8359 7.50033H16.6693",
    fill: "#F5F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReports);
export default __webpack_public_path__ + "static/media/sidebar_reports.679d3b5a434cc038f81a218283b7dfef.svg";
export { ForwardRef as ReactComponent };